// frontend/packages/business-console/src/pages/SentryDebug.js
//
// Temporary verification page for the Sentry integration. Wired into the
// business-console router at /sentry-debug. Delete this file and the route
// once Sentry receipt is confirmed in the dashboard.

import React from "react";

export default function SentryDebug() {
  const [boom, setBoom] = React.useState(false);

  const throwSync = () => {
    throw new Error("sentry-debug: synchronous throw from button handler");
  };

  const throwInRender = () => {
    // Force a re-render that throws inside the React commit phase so the
    // ErrorBoundary catches it (window.onerror would not).
    setBoom(true);
  };

  if (boom) {
    throw new Error("sentry-debug: thrown inside React render to test ErrorBoundary");
  }

  return (
    <div style={{ padding: 24, fontFamily: "system-ui, sans-serif" }}>
      <h1>Sentry debug</h1>
      <p>Use these buttons to confirm browser events reach Sentry.</p>
      <button onClick={throwSync} style={{ marginRight: 12 }}>
        Throw uncaught error (window.onerror path)
      </button>
      <button onClick={throwInRender}>Trigger ErrorBoundary fallback</button>
    </div>
  );
}
